import React, { useEffect, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch, Provider } from "react-redux";

import { Link } from "react-router-dom";
import { NavTop } from "header/headerStyle";
import { FaRegUser } from "react-icons/fa";
import { IoIosConstruct, IoMdExit } from "react-icons/io";

import { customStore } from "reducer/store";

import { LPAD, useDebounce } from "util";

import styled from "styled-components";
import openDatabase, { deleteAllDatabase } from "util/autoSave";

const Blanket = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 50;
`

const InitialBtn = styled.div`
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
    background-color: #FFF;
    border-radius: 15px;
    padding: 10px;
    box-shadow: rgb(170, 170, 170) 4px 5px 5px 0px;
    border: 0.5px solid rgb(150,150,150);
    z-index: 60;
    & button {
        background-color: #FFF;
        padding: 5px;
        border: 2px solid var(--danger-color)!important;
        border-radius: 15px;
        width: 100%;
        cursor: pointer;
        color: var(--danger-color);
        &:hover {
            background-color: var(--danger-color);
            color: #FFF;
        }
    }
`

// import BatchImage from 'images/batch.png'
// <img src={BatchImage} alt="" />

const Time = () => {
    const time = useSelector((store) => store.serverTime);
    const [timeState, setTimeState] = useState(new Date(time));
    const tmout = useRef(null);

    const getTime = (time) => {
        setTimeState(new Date(time));

        tmout.current = setInterval(() => {
            setTimeState((OLD) => {
                const a = new Date(OLD);
                a.setSeconds(a.getSeconds() + 1);
                return a;
            });
        }, 1000);
    };

    useEffect(() => {
        clearInterval(tmout.current);
        getTime(time);
    }, [time]);

    return (
        <p style={{ fontSize: "12px" }}>
            {timeState.toISOString().replace(/^([0-9]+)-([0-9]+)-([0-9]+)T([0-9]+):([0-9]+):([0-9]+)\..*$/i, "$3/$2/$1 $4:$5:$6")}{" "}
            KST
        </p>
    );
};

const Nav = () => {
    const user = useSelector((store) => store.user);
    const common = useSelector((store) => store.common);
    const logedin = user.userId !== null;
    const { t, i18n } = useTranslation(["page"]);
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    const changeLanguage = (lang) => {
        dispatch({ type: "SET_LANG", lang: lang });
        i18n.changeLanguage(lang);
    };

    useEffect(() => {
        if (!common.lang) {
            const lang = i18n.language;
            i18n.changeLanguage(lang);
            dispatch({ type: "SET_LANG", lang: lang });
        } else {
            i18n.changeLanguage(common.lang);
        }
    }, []);

    const handleAction = () => {
        const yn = window.confirm("This action will erase all auto-saved data and cannot be undone.\nDo you wish to proceed?")
        if(yn) {
            window.alert("All databases deleted successfully.")
            deleteAllDatabase();
        }
        setOpen(!open)
    }

    return (
        <NavTop>
            <div className="navWrap">
                <ul>
                    <Provider store={customStore}>
                        <Time />
                    </Provider>
                    <li className="lang">
                        <button
                            className={`${i18n.language === "ko" ? "on" : ""}`}
                            onClick={() => {
                                changeLanguage("ko");
                            }}
                        >
                            KO
                        </button>
                        <button
                            className={`${i18n.language === "en" ? "on" : ""}`}
                            onClick={() => {
                                changeLanguage("en");
                            }}
                        >
                            EN
                        </button>
                    </li>
                    {logedin ? (
                        <>
                            <li style={{position: "relative"}}>
                                <span style={{ marginRight: "3px" }}>
                                    <FaRegUser style={{ fontSize: "15px" }} />
                                </span>
                                <span>{user.userNm}</span>
                            </li>
                            <li>
                                <Link to={`/logout`}>
                                    <IoMdExit />
                                </Link>
                            </li>
                        </>
                    ) : (
                        <li>
                            <Link to={`/login`}>Login</Link>
                        </li>
                    )}

                    {/* <li className='navIcon'><Link to={`/`}><FaRegUser /></Link></li> */}
                </ul>
            </div>
        </NavTop>
    );
};
export default Nav;
